import { Search } from '@moovly/dashboard-global';
import { t } from '@moovly/i18n';
import * as React from 'react';
import './UserSearch.scss';
interface UserSearchInputProps {
  onSubmit: (value: string) => void;
  onReset: () => void;
}

const UserSearch: React.FC<UserSearchInputProps> = (props) => {
  return (
    <div className="SearchWrapper">
      <Search placeholder={t('placeholders.userSearch')} {...props} />
    </div>
  );
};

export default UserSearch;
